/**
 * @deprecated This file is deprecated and in migration to the new analytics architecture.
 * @see {@link ../analytics/README.md} for the new analytics system.
 * @todo Migrate to the new analytics system in src/core/analytics/
 */
import { getCookieValue } from "@utils/browser-features";
import { handleResponseError } from "@utils/error-utils/response-error-handlers";

export async function findUser(userId: string): Promise<Record<string, unknown>> {
  return await fetch(`${process.env.GATSBY_API_BASE}/analytics_user/${userId}`, {
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.GATSBY_API_TOKEN}`,
    },
  }).then(async (res: Response): Promise<Record<string, unknown>> => {
    if (!res.ok) {
      await handleResponseError(res);
    }

    return res.json();
  });
}

export const getMetaFbp = (): string | null => {
  const metaFbp = getCookieValue("_fbp");

  return metaFbp ? metaFbp : null;
};

export const getMetaFbc = (): string | null => {
  const metaFbc = getCookieValue("_fbc");

  return metaFbc ? metaFbc : null;
};
